import { Form } from 'formik';
import { FormikDebounce } from '../common/form/FormikDebounce';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useAppDispatch } from '../../store';
import { storageResetAction } from '../../store/storeReset';
import { logout } from '../../utils/storage';
import { SubmitButton } from '../common/form/SubmitButton';
import { Input } from '../common/form/Input';
import { LoginContainer, LoginWrapper } from './LoginStyles';
import { SectionHeader } from '../common/SectionHeader';
import * as Yup from 'yup';
import { validations } from '../../utils/validations';
import { SubmitApplicationInvitation } from '@api/models/application/SubmitApplicationInvitation';
import { ShowError } from '../ShowError';
import { resources } from '@api/resources';
import { applicationInvitationService } from '@api/services/services';

export const AppInvitation: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token = params.get('token')!;
  const email = params.get('email')!;

  useEffect(() => {
    logout();
    dispatch(storageResetAction());

    // don't fire on any change
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (data: SubmitApplicationInvitation) => {
    await applicationInvitationService.submitApplicationInvitation(data);
    navigate('/');
  };

  return (
    <LoginWrapper>
      <SectionHeader title="auth.invitation" />
      <FormikDebounce<SubmitApplicationInvitation>
        initialValues={{
          id: token,
          email,
          password: '',
          repeatedPassword: '',
        }}
        validationSchema={Yup.object({
          repeatedPassword: validations.stringRequired(t).oneOf([Yup.ref('password')], t('auth.passwordMismatch')!),
        })}
        onSubmit={handleSubmit}
      >
        <Form>
          <LoginContainer>
            <Input name="password" type="password" label={t('auth.password')} autoComplete="off" />
            <Input name="repeatedPassword" type="password" label={t('auth.passwordAgain')} autoComplete="off" />

            <SubmitButton text="auth.setPassword" />
            <ShowError resource={resources.submitApplicationInvitation} />
          </LoginContainer>
        </Form>
      </FormikDebounce>
    </LoginWrapper>
  );
};
